import { isPlainObject } from 'lodash';

export const isMobile = ((): boolean => {
  if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
    return false;
  }
  return /Mobile/.test(navigator.userAgent);
})();

// This function ensures that the user has granted the browser permission to use audio and video
// devices. If permission has not been granted, it will cause the browser to ask for permission
// for audio and video at the same time (as opposed to separate requests).
export async function ensureMediaPermissions(): Promise<void> {
  return navigator.mediaDevices
    .enumerateDevices()
    .then((devices) => devices.every((device) => !(device.deviceId && device.label)))
    .then((shouldAskForMediaPermissions) => {
      if (shouldAskForMediaPermissions) {
        return navigator.mediaDevices
          .getUserMedia({ audio: true, video: true })
          .then((mediaStream) => mediaStream.getTracks().forEach((track) => track.stop()));
      }
    });
}

// Recursively removes any object keys with a value of undefined
export function removeUndefineds<T>(obj: T): T {
  if (!isPlainObject(obj)) {return obj;}

  const target: { [name: string]: any } = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const val = obj[key];
      if (typeof val !== 'undefined') {
        target[key] = removeUndefineds(val);
      }
    }
  }

  return target as T;
}

export function showUpgradeModel(isShow: boolean, title='', body=''): void {
  if (isShow) {
    document.getElementById('upgradeNotificationTitle').innerHTML = title;
    document.getElementById('upgradeNotificationBody').innerHTML = body;
    document.querySelector('.modal').classList.add('show');
    document.getElementById('upgradeModal').style.display = 'block';
  } else {
    document.getElementById('upgradeNotificationTitle').innerHTML = '';
    document.getElementById('upgradeNotificationBody').innerHTML = '';
    document.querySelector('.modal').classList.remove('show');
    document.getElementById('upgradeModal').style.display = 'none';
  }
}
